import SocialModal from './SocialModal';

export default SocialModal;
